import { InternetProduct, PlcCodes } from '@dch/products-business-logic';
import { Router } from '@angular/router';

export function openProductURL(appType: InternetProduct, router: Router) {
  switch (appType.plc) {
    case PlcCodes.MMAL:
      router.navigate(['/details/mail']);
      break;
    case PlcCodes.CLD:
      router.navigate(['/cloud']);
      break;
    case PlcCodes.FI:
      router.navigate(['/public-wifi']);
      break;
    default:
      router.navigate(['/']);
      break;
  }
}
